import React, { Component } from 'react';
import Breadcrumb from "../common/breadcrumb";
import { getFaqUrl } from "../../services";
import { getCall } from "../../api/post";

class Faq extends Component {
    state = {
        faqData: [],
        loading: true,
        error: null,
    };

    componentDidMount() {
        this.fetchFaqs();
    }

    fetchFaqs = async () => {
        try {
            const faqUrl = getFaqUrl();
            const response = await getCall(faqUrl, []);
            if (response.error) {
                throw new Error(response.error.message || "Failed to fetch FAQs");
            }
            this.setState({
                faqData: response.data || [],
                loading: false,
            });
        } catch (error) {
            this.setState({
                error: error.message,
                loading: false,
            });
        }
    };

    render() {
        const { faqData, loading, error } = this.state;

        return (
            <div>
                <Breadcrumb title={'FAQ'} />

                {/*FAQ section*/}
                <section className="faq-section section-b-space">
                    <div className="container">
                        <div className="row">
                            {/* Contact Information Sidebar (static) */}
                            <div className="col-lg-3">
                                <div style={{
                                    backgroundColor: '#f8f9fa',
                                    padding: '30px',
                                    borderRadius: '8px',
                                    height: 'fit-content'
                                }}>
                                    <p style={{ marginBottom: '10px' }}>
                                        If you have any questions, please email us at{' '}
                                        <a href="mailto:rewards@rezlive.com" style={{ color: '#f39e1d' }}>
                                            rewards@rezlive.com
                                        </a>
                                    </p>
                                </div>
                            </div>

                            {/* FAQ Content (dynamic from API) */}
                            <div className="col-lg-9">
                                <div className="faq-content">
                                    <h3 style={{
                                        fontWeight: 'bold',
                                        marginBottom: '30px',
                                        color: '#333'
                                    }}>
                                        Frequently Asked Questions
                                    </h3>
                                    {loading ? (
                                        <div style={{ textAlign: 'center', padding: '50px' }}>
                                            <p>Loading FAQs...</p>
                                        </div>
                                    ) : error ? (
                                        <div style={{
                                            backgroundColor: '#f8d7da',
                                            border: '1px solid #f5c6cb',
                                            color: '#721c24',
                                            padding: '15px',
                                            borderRadius: '5px',
                                            marginBottom: '20px'
                                        }}>
                                            <p>Error loading FAQs: {error}</p>
                                        </div>
                                    ) : (
                                        faqData.length > 0 ? (
                                            faqData.map((sectionObj, idx) => (
                                                <div className="faq-section-group" style={{ marginBottom: '40px' }} key={idx}>
                                                    <h3 style={{
                                                        fontWeight: 'bold',
                                                        marginBottom: '20px',
                                                        color: '#333'
                                                    }}>
                                                        {sectionObj.section}
                                                    </h3>
                                                    {sectionObj.faqs.map((faq) => (
                                                        <div className="faq-item" style={{ marginBottom: '25px' }} key={faq.id}>
                                                            <h5 style={{
                                                                color: '#f39e1d',
                                                                fontWeight: 'bold',
                                                                marginBottom: '10px'
                                                            }}>
                                                                {faq.question}
                                                            </h5>
                                                            <p style={{ color: '#333', lineHeight: '1.6' }}>
                                                                {faq.answer}
                                                            </p>
                                                            <hr style={{
                                                                border: 'none',
                                                                borderTop: '1px solid #e0e0e0',
                                                                margin: '20px 0'
                                                            }} />
                                                        </div>
                                                    ))}
                                                </div>
                                            ))
                                        ) : (
                                            <div>No FAQs found.</div>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Faq;